var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.302 5.568a11.08 11.08 0 0 1 11.83-4.189c5.893 1.574 9.403 7.604 7.824 13.475-1.578 5.87-7.64 9.34-13.533 7.767a11.04 11.04 0 0 1-8.01-8.594l-.067-.391-.01-.103a1 1 0 0 1 1.987-.2A9.04 9.04 0 0 0 9.94 20.69c4.836 1.29 9.796-1.562 11.085-6.356s-1.574-9.732-6.41-11.023A9.08 9.08 0 0 0 4.95 6.7l2.615-.89.099-.028a1.001 1.001 0 0 1 .642 1.884l-.095.038-5.03 1.714a1.002 1.002 0 0 1-1.306-.753L.845 3.452a1.001 1.001 0 0 1 1.962-.387z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.335 5.548a1 1 0 0 1 1 1v5.033l2.084 2.062.07.075a1 1 0 0 1-1.399 1.415l-.076-.068-2.383-2.354a1 1 0 0 1-.296-.71V6.547a1 1 0 0 1 1-1"
  })));
};
export default Svg24;